import fetchWithReporter from './fetchWithReporter';
import reportError from './reportError';
import { getLogSuccess } from './selectors';

export function getUserNameByUserId({ id, url }) {
  return (dispatch, getState) => {
    const state = getState();
    const errorReporter = (error, otherData) => {
      dispatch(
        reportError(error, {
          ...otherData,
          collectionMethod: 'getUserNameByUserId',
        })
      );
      return '';
    };
    const body = JSON.stringify({ userId: id });
    return fetchWithReporter(`${url}/ReadUserNameFromUserId.v1`, {
      method: 'POST',
      body,
      timeout: 9e3,
      errorReporter,
      logSuccess: getLogSuccess(state),
    }, state)
      .then((data) => data.json())
      .then((data) => data.embossedName || '')
      .catch((err) => errorReporter(err));
  };
}
